import { render, staticRenderFns } from "./HistoricalReport.vue?vue&type=template&id=2022ce35"
import script from "./HistoricalReport.vue?vue&type=script&lang=js"
export * from "./HistoricalReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports